<div
  class="item"
  [class.item--x-small]="size === 'x-small'"
  [class.item--small]="size === 'small'"
  [class.item--medium]="size === 'medium'"
  [class.item--large]="size === 'large'"
  [class.item--x-large]="size === 'x-large'"
  [class.item--selected]="selected"
  [class.item--transparent]="isTransparent"
  [style.background-image]="getBackgroundCSS()">
</div>